exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".previewer>circle[data-v-3cb3d967],.previewer>g[data-v-3cb3d967],.previewer>rect[data-v-3cb3d967]{fill:#b7babd;transition:fill .5s ease}.previewer>circle.active[data-v-3cb3d967],.previewer>g.active[data-v-3cb3d967],.previewer>rect.active[data-v-3cb3d967]{fill:#94719c;fill:#35bacf}.preview-container.with-thing[data-v-3cb3d967]{background:url(/assets/img/onboarding-start.png);padding:100px 50px;max-width:375px;background-size:contain;background-position:50%;background-repeat:no-repeat;margin:0 auto}@media (max-width:800px){.preview-container.with-thing[data-v-3cb3d967]{padding:70px 50px;margin-bottom:-56px;max-width:300px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-3cb3d967","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Preview.vue
// module id = 49
// module chunks = 0